import {
  AlgoliaSearchVehicleResponse,
  VehicleSearchOptions,
  VehicleSearchParams,
} from '@api-client/src/api/types';
import { useSearchFactory } from '@vue-storefront/core';

const useVehicleSearch = useSearchFactory<AlgoliaSearchVehicleResponse, VehicleSearchOptions>({
  search: async (context, options) => {
    const DEFAULT_VEHICLES_INDEX = 'vehicles';
    const indexName =
      context.$search.config.app.$config.vehicleIndexAlgolia ?? DEFAULT_VEHICLES_INDEX;
    const { vehicleIds, resultsPerPage, facets, filters, facetFilters, query } = options;
    const params: VehicleSearchParams = { hitsPerPage: 1 };

    params.hitsPerPage = resultsPerPage;
    params.facets = facets;
    params.filters = filters;
    params.facetFilters = facetFilters;
    params.query = query;

    // TODO: check
    if (vehicleIds) {
      const vehicleIdsFilter = vehicleIds
        .map((vehicleId: number) => `VehicleID:"${vehicleId}"`)
        .join(' OR ');
      if (params.filters) {
        params.filters = `${params.filters} AND ${vehicleIdsFilter}`;
      } else {
        params.filters = vehicleIdsFilter;
      }
    }

    try {
      const vehicleSearchResult = await context.$search.api.vehicleSearch([
        {
          indexName,
          ...params,
        },
      ]);

      return vehicleSearchResult;
    } catch (e) {
      console.error(e);

      return null;
    }
  },
});

export default useVehicleSearch;
